export default __webpack_public_path__ + "static/media/instructor.58f7cb9b.jpg";